import * as request from '@/utils/request'

export default {
  /**
   * @description 获取发票代开邀请码
   * @author YM
   * @date 2019-03-04
   * @param {*} data
   * @returns
   */
  getInvoiceCode(data) {
    return request.get('/invoice_agent/invitation_code', data)
  },

  /**
   * @description 获取集群注册邀请码
   * @author YM
   * @date 2019-03-04
   * @param {*} data
   * @returns
   */
  getRegisterCode(data) {
    return request.get('/individual/invitation_code', data)
  },
  // 获取集群注册二维码
  getRegisterQrCode(data) {
    return request.get('/individual/invitation_qrcode', data)
  },

    /**
   * @description 获取发票代开列表
   * @author YM
   * @date 2021-08-04
   * @param {*} data
   * @returns
   */
  //由于本地和测试的接口不一致，注释掉这个10/19
  getInvoiceLists(data){
    return request.get('/invoice_agent/list', data)
  }
}